import React from "react"
import { Outlet, Link } from "react-router-dom";

const Footer = () => {

  const privacy = "Privacy Notice "
  const use = " Terms of use"

  return (
    // <footer className="bg-primary text-white py-2 px-4">
    //   <div>© 2024 Aenduo S.r.l.</div>
    // </footer>
    <footer className="bg-primary text-white py-2 px-4">
      <div>© {new Date().getFullYear()} Aenduo S.r.l.</div>
      <div className="flex gap-4">
        <Link to="/privacy-policy" className="cursor-pointer">{privacy}</Link> |
        <Link to="/terms-of-use" className="cursor-pointer">{use}</Link>
      </div>
    </footer>
  )
}

export default Footer
